<template>
  <div class="general-info-wrapper">
    <icon-view
      :has-border="false"
      icon="fas fa-info-circle color-orange"
      icon-size="1rem"
      title="Información Adicional"
      variant="custom-icon-view"
    />
    <div class="row mx-0 mb-3">
      <div class="col-12 col-md-3 mb-3 mb-md-0">
        <span class="data-title">
          Proveedor:
        </span>
        <span class="label">
          {{ info.provider | empty }}
        </span>
      </div>
      <div class="col-12 col-md-3 mb-3 mb-md-0">
        <span class="data-title">
          Lugar de Servicio:
        </span>
        <span class="label">
          {{ info.servicePlace | empty }}
        </span>
      </div>
      <div class="col-12 col-md-3 mb-3 mb-md-0">
        <span class="data-title">
          Asistente de servicios:
        </span>
        <span class="label">
          {{ info.serviceAssistant | empty }}
        </span>
      </div>
    </div>
    <icon-view
      :has-border="false"
      icon="fas fa-info-circle color-orange"
      icon-size="1rem"
      title="Información de Servicios"
      variant="custom-icon-view"
    />
    <div class="row mx-0 mb-3">
      <div class="col-12 col-md-3 mb-3 mb-md-0">
        <span class="data-title">
          Total de Servicios:
        </span>
        <span class="label">
          {{ info.totalServices | empty }}
        </span>
      </div>
      <div class="col-12 col-md-3 mb-3 mb-md-0">
        <span class="data-title">
          M&iacute;nimo:
        </span>
        <span class="label">
          {{ info.minServiceDate | date | empty }}
        </span>
      </div>
      <div class="col-12 col-md-3 mb-3 mb-md-0">
        <span class="data-title">
          M&aacute;ximo:
        </span>
        <span class="label">
          {{ info.maxServiceDate | date | empty }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from 'icon-view';
import { getValidityGeneralInformation } from '@/services/api/tapRequest.api.js';

export default {
  name: 'ValidityGeneralInfo',
  components: { IconView },
  props: {
    requestId: {
      type: Number,
      default: null,
    },
    academicYearId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    info: {},
  }),
  async created() {
    await this.getInitialInfo();
  },
  methods: {
    async getInitialInfo() {
      const { data } = await getValidityGeneralInformation(
        this.requestId,
        this.academicYearId
      );
      this.info = { ...data };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.general-info-wrapper ::v-deep {
  .label {
    margin: 0 !important;
  }
  .custom-icon-view {
    margin-bottom: 0.5rem;
    .dot {
      box-shadow: none !important;
      margin-right: 0.5rem !important;
      .title-icon {
        margin: 0 !important;
      }
    }
    .font-16.color-gray-7 {
      font-size: 1rem !important;
      color: map-get($colors, 'gray-7') !important;
    }
  }
}
</style>
